import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import './styles/element-variables.scss'
import './assets/iconfont/iconfont.css'
import 'nprogress/nprogress.css'
import './styles/common.scss'

Vue.config.productionTip = false

Vue.use(Element)

// 移除el-radio-group的aria-hidden属性
Vue.directive('removeAriaHidden', {
    bind(el, binding) {
        const ariaEls = el.querySelectorAll('.el-radio__original');
        ariaEls.forEach((item) => {
            item.removeAttribute('aria-hidden');
        });
    }
});

// 按钮权限自定义指令
// Vue.directive('auth', {
//     inserted(el, binding) {
//         const authVal = binding.value
//         const authBtns = store.state.authBtns
//         if (!authBtns.includes(authVal)) {
//             el.remove()
//         }
//     }
// })

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
